// extracted by mini-css-extract-plugin
export default {"devider":"OrDevider_devider__Iqi94","line":"OrDevider_line__JEE-d"};